import netent from './netent.webp';
import redTiger from './red-tiger.webp';
import wizard from './wizard.webp';
import bigTimeGaming from './big-time-gaming.webp';
import pragmaticPlay from './pragmatic-play.webp';
import relax from './relax.webp';
import igt from './igt.webp';
import reelPlay from './reelplay.webp';
import spinberry from './spinberry.webp';
import wazdan from './wazdan.webp';
import hacksaw from './hacksaw.webp';
import playson from './playson.webp';
import inspired from './inspired.webp';
import noLimitCity from './nolimit-city.webp';
import playNGo from './playngo.webp';
import slingo from './slingo.webp';
import quickspin from './quickspin.webp';
import everi from './everi.webp';
import eyecon from './eyecon.webp';
import blueprint from './blueprint.webp';
import rawGaming from './raw-gaming.webp';
import gamomat from './gamomat.webp';
import oryx from './oryx.webp';
import greentube from './greentube.webp';
import skywind from './skywind.webp';
import slotmill from './slotmill.webp';
import wildStreakGaming from './wild-streak-gaming.webp';
import skillzGaming from './skillz-gaming.webp';
import stakelogic from './stakelogic.webp';
import fantasmaGames from './fantasma-games.webp';
import swintt from './swintt.webp';
import fourThePlayer from './four-the-player.webp';
import printStudios from './print-studios.webp';
import peterAndSons from './peter-and-sons.webp';
import stormGaming from './storm-gaming.webp';
import jadeRabbit from './jade-rabbit.webp';
import spinGames from './spin-games.webp';
import gamesGlobal from './games-global.webp';
import blueGuruGames from './blue-guru-games.webp';
import goldenRock from './golden-rock.webp';
import fourLeafGaming from './four-leaf-gaming.webp';
import avatarUx from './avatar-ux.webp';
import silverbackGaming from './silverback-gaming.webp';
import high5Games from './high-5-games.webp';
import indigoMagic from './indigo-magic.webp';
import backseatGaming from './backseat-gaming.webp';
import bullsharkGaming from './bullshark-gaming.webp';
import nowNowGaming from './now-now-gaming.webp';
import trustyGaming from './trusty-gaming.webp';
import kitsuneStudios from './kitsune-studios.webp';
import lightAndWonder from './light-and-wonder.webp';
import ags from './ags.webp';
import oneX2Network from './1x2-network.webp';
import bragg from './bragg.webp';
import konami from './konami.webp';
import redRake from './red-rake.webp';
import thunderkick from './thunderkick.webp';
import elk from './elk.webp';
import aceRoll from './ace-roll.webp';
import aristocrat from './aristocrat.webp';
import dwg from './dwg.webp';

export default {
  '1': wizard,
  '2': netent,
  '3': redTiger,
  '4': bigTimeGaming,
  '5': pragmaticPlay,
  '6': relax,
  '7': igt,
  '8': reelPlay,
  '9': spinberry,
  '10': wazdan,
  '11': hacksaw,
  '12': playson,
  '13': inspired,
  '14': noLimitCity,
  '15': playNGo,
  '16': slingo,
  '17': quickspin,
  '18': everi,
  '19': eyecon,
  '20': blueprint,
  '21': rawGaming,
  '22': high5Games,
  '23': gamomat,
  '24': oryx,
  '27': indigoMagic,
  '28': skywind,
  '29': slotmill,
  '30': wildStreakGaming,
  '31': skillzGaming,
  '32': spinGames,
  '33': stakelogic,
  '34': fantasmaGames,
  '35': swintt,
  '36': fourThePlayer,
  '37': printStudios,
  '38': peterAndSons,
  '39': stormGaming,
  '40': jadeRabbit,
  '41': gamesGlobal,
  '42': blueGuruGames,
  '43': goldenRock,
  '44': fourLeafGaming,
  '45': avatarUx,
  '46': silverbackGaming,
  '47': backseatGaming,
  '48': bullsharkGaming,
  '49': nowNowGaming,
  '50': trustyGaming,
  '51': kitsuneStudios,
  '52': lightAndWonder,
  '53': ags,
  '54': oneX2Network,
  '55': bragg,
  '56': konami,
  '57': greentube,
  '58': redRake,
  '59': thunderkick,
  '60': elk,
  '61': aceRoll,
  '63': aristocrat,
  '64': dwg,
};
